import React, { PropsWithChildren } from 'react'

const LoaderContainer: React.FC <PropsWithChildren<any>> = ({ children }) => {
    return <div className = "loaderContainer">{children}</div>
}

export default LoaderContainer